const TangoCanasta = {
    name: "Tango Canasta",
    bpm: 104,
    signature: "4/4",
    introMeasures: 8,
    pattern: [
        { cue: '1 l o, into 1 r i prog, into 1 l o, into  1  r i chassay', totalBeats: 4 },
        { cue: '4 l o swing', totalBeats: 4 },
        { cue: '2 r o swing, into 2 l i slide chassay', totalBeats: 4 },
        { cue: '4 r o swing', totalBeats: 4 },
        { cue: '2 l o, into 2 r i slide chassay', totalBeats: 4 },
        { cue: '1 l o, into 1 r i prog, into 2 l o, into 4 r o swing', totalBeats: 8},
        { cue: 'repeat pattern', totalBeats: 0 },
    ]
};

export default TangoCanasta;